import { render, staticRenderFns } from "./PatientVideoRoom.vue?vue&type=template&id=7914a297&scoped=true&lang=pug"
import script from "./PatientVideoRoom.vue?vue&type=script&lang=js"
export * from "./PatientVideoRoom.vue?vue&type=script&lang=js"
import style0 from "./PatientVideoRoom.vue?vue&type=style&index=0&id=7914a297&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7914a297",
  null
  
)

export default component.exports